import { useQuery } from '@tanstack/react-query';

import { useUserInfo } from 'Store/userInfo';
import getReportAttendanceHost from 'Api/report-attendance/getReportAttendanceHost';

import getReportAttendanceHostRequest from './model/request/getReportAttendanceHostRequest';
import getReportAttendanceHostResponse from './model/response/getReportAttendanceHostResponse';

const useGetReportAttendanceHost = ({ filter, enabled }) => {
  const { roleName } = useUserInfo();
  return useQuery({
    queryKey: ['report-attendance-host', filter],
    queryFn: async () => {
      const queries = getReportAttendanceHostRequest(filter);

      const response = await getReportAttendanceHost(queries);

      return getReportAttendanceHostResponse(response);
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled: roleName === 'Owner' && enabled,
  });
};

export default useGetReportAttendanceHost;
